import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="mobile-menu"
export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.isOpen = false
  }

  displayMobileMenu(event) {
    this.isOpen = !this.isOpen
    this.menuTarget.classList.toggle('hidden')

    // Update aria-expanded on the trigger button
    const button = event.currentTarget
    button.setAttribute("aria-expanded", this.isOpen.toString())

    if (this.isOpen) {
      this._triggerButton = button
    } else if (this._triggerButton) {
      this._triggerButton.focus()
      this._triggerButton = null
    }
  }

  close(event) {
    if (event.key === "Escape" && this.isOpen) {
      this.isOpen = false
      this.menuTarget.classList.add('hidden')

      if (this._triggerButton) {
        this._triggerButton.setAttribute("aria-expanded", "false")
        this._triggerButton.focus()
        this._triggerButton = null
      }
    }
  }
}
